/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as OrganizationImport } from './routes/organization'
import { Route as JobsImport } from './routes/jobs'
import { Route as InventoryImport } from './routes/inventory'
import { Route as HealthCheckImport } from './routes/health-check'
import { Route as FallbackImport } from './routes/_fallback'
import { Route as WalkdownsRouteImport } from './routes/walkdowns.route'
import { Route as ViewerRouteImport } from './routes/viewer.route'
import { Route as PartsRouteImport } from './routes/parts.route'
import { Route as ExplorerRouteImport } from './routes/explorer.route'
import { Route as AssetsRouteImport } from './routes/assets.route'
import { Route as ExplorerIndexImport } from './routes/explorer.index'
import { Route as RedirectsIndexImport } from './routes/_redirects/index'
import { Route as WorkOrderWorkOrderIDImport } from './routes/work-order.$workOrderID'
import { Route as UsersOrgIDImport } from './routes/users.$orgID'
import { Route as SubAssemblySubAssemblyIDImport } from './routes/sub-assembly.$subAssemblyID'
import { Route as SchedulingSiteIDImport } from './routes/scheduling.$siteID'
import { Route as PointCloudSiteIDImport } from './routes/point-cloud.$siteID'
import { Route as OverviewSiteIDImport } from './routes/overview.$siteID'
import { Route as OrganizationOrgIDImport } from './routes/organization.$orgID'
import { Route as NoSitesOrgIDImport } from './routes/no-sites.$orgID'
import { Route as MaximoSiteIDImport } from './routes/maximo.$siteID'
import { Route as JobSiteIDImport } from './routes/job.$siteID'
import { Route as InspectionsSiteIDImport } from './routes/inspections.$siteID'
import { Route as HealthPlansSiteIDImport } from './routes/health-plans.$siteID'
import { Route as ForgingEntryIDImport } from './routes/forging.$entryID'
import { Route as ExtensionsOrgIDImport } from './routes/extensions.$orgID'
import { Route as ExplorerSiteIDImport } from './routes/explorer.$siteID'
import { Route as EquipmentEquipmentIDImport } from './routes/equipment.$equipmentID'
import { Route as DrilldownExplorationSiteIDImport } from './routes/drilldown-exploration.$siteID'
import { Route as DetailsEntryIDImport } from './routes/details.$entryID'
import { Route as AssemblyAssemblyIDImport } from './routes/assembly.$assemblyID'
import { Route as AdminUsersImport } from './routes/admin.users'
import { Route as RedirectsLandingImport } from './routes/_redirects/landing'
import { Route as WalkdownsSiteIDIndexImport } from './routes/walkdowns.$siteID.index'
import { Route as ProcessFlowsSiteIDIndexImport } from './routes/process-flows.$siteID.index'
import { Route as PointCloudSiteIDIndexImport } from './routes/point-cloud.$siteID.index'
import { Route as PartsSiteIDIndexImport } from './routes/parts.$siteID.index'
import { Route as AssetsSiteIDIndexImport } from './routes/assets.$siteID.index'
import { Route as AssetAssessmentSiteIDIndexImport } from './routes/asset-assessment.$siteID.index'
import { Route as WalkdownsSiteIDWalkdownIdImport } from './routes/walkdowns.$siteID.$walkdownId'
import { Route as ViewerUnitIDInspectionImport } from './routes/viewer.$unitID.inspection'
import { Route as ViewerUnitIDConfigurationImport } from './routes/viewer.$unitID.configuration'
import { Route as ProcessFlowsSiteIDDiagramIDImport } from './routes/process-flows.$siteID.$diagramID'
import { Route as PointCloudSiteIDPointCloudOrSceneIDImport } from './routes/point-cloud.$siteID.$pointCloudOrSceneID'
import { Route as OrganizationOrgIDSiteImport } from './routes/organization_.$orgID.site'
import { Route as AssetsSiteIDUnitIDImport } from './routes/assets.$siteID.$unitID'
import { Route as AssetLensSiteIDUnitIDImport } from './routes/asset-lens.$siteID.$unitID'
import { Route as AssetAssessmentSiteIDUnitIDImport } from './routes/asset-assessment.$siteID.$unitID'
import { Route as RedirectsSiteViewSiteIDImport } from './routes/_redirects/site-view.$siteID'
import { Route as OrganizationOrgIDSiteSiteIDImport } from './routes/organization_.$orgID.site.$siteID'

// Create Virtual Routes

const AboutLazyImport = createFileRoute('/about')()

// Create/Update Routes

const AboutLazyRoute = AboutLazyImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))

const OrganizationRoute = OrganizationImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => rootRoute,
} as any)

const JobsRoute = JobsImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => rootRoute,
} as any)

const InventoryRoute = InventoryImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRoute,
} as any)

const HealthCheckRoute = HealthCheckImport.update({
  id: '/health-check',
  path: '/health-check',
  getParentRoute: () => rootRoute,
} as any)

const FallbackRoute = FallbackImport.update({
  id: '/_fallback',
  getParentRoute: () => rootRoute,
} as any)

const WalkdownsRouteRoute = WalkdownsRouteImport.update({
  id: '/walkdowns',
  path: '/walkdowns',
  getParentRoute: () => rootRoute,
} as any)

const ViewerRouteRoute = ViewerRouteImport.update({
  id: '/viewer',
  path: '/viewer',
  getParentRoute: () => rootRoute,
} as any)

const PartsRouteRoute = PartsRouteImport.update({
  id: '/parts',
  path: '/parts',
  getParentRoute: () => rootRoute,
} as any)

const ExplorerRouteRoute = ExplorerRouteImport.update({
  id: '/explorer',
  path: '/explorer',
  getParentRoute: () => rootRoute,
} as any)

const AssetsRouteRoute = AssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => rootRoute,
} as any)

const ExplorerIndexRoute = ExplorerIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ExplorerRouteRoute,
} as any)

const RedirectsIndexRoute = RedirectsIndexImport.update({
  id: '/_redirects/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const WorkOrderWorkOrderIDRoute = WorkOrderWorkOrderIDImport.update({
  id: '/work-order/$workOrderID',
  path: '/work-order/$workOrderID',
  getParentRoute: () => rootRoute,
} as any)

const UsersOrgIDRoute = UsersOrgIDImport.update({
  id: '/users/$orgID',
  path: '/users/$orgID',
  getParentRoute: () => rootRoute,
} as any)

const SubAssemblySubAssemblyIDRoute = SubAssemblySubAssemblyIDImport.update({
  id: '/sub-assembly/$subAssemblyID',
  path: '/sub-assembly/$subAssemblyID',
  getParentRoute: () => rootRoute,
} as any)

const SchedulingSiteIDRoute = SchedulingSiteIDImport.update({
  id: '/scheduling/$siteID',
  path: '/scheduling/$siteID',
  getParentRoute: () => rootRoute,
} as any)

const PointCloudSiteIDRoute = PointCloudSiteIDImport.update({
  id: '/point-cloud/$siteID',
  path: '/point-cloud/$siteID',
  getParentRoute: () => rootRoute,
} as any)

const OverviewSiteIDRoute = OverviewSiteIDImport.update({
  id: '/overview/$siteID',
  path: '/overview/$siteID',
  getParentRoute: () => rootRoute,
} as any)

const OrganizationOrgIDRoute = OrganizationOrgIDImport.update({
  id: '/$orgID',
  path: '/$orgID',
  getParentRoute: () => OrganizationRoute,
} as any)

const NoSitesOrgIDRoute = NoSitesOrgIDImport.update({
  id: '/no-sites/$orgID',
  path: '/no-sites/$orgID',
  getParentRoute: () => rootRoute,
} as any)

const MaximoSiteIDRoute = MaximoSiteIDImport.update({
  id: '/maximo/$siteID',
  path: '/maximo/$siteID',
  getParentRoute: () => rootRoute,
} as any)

const JobSiteIDRoute = JobSiteIDImport.update({
  id: '/job/$siteID',
  path: '/job/$siteID',
  getParentRoute: () => rootRoute,
} as any)

const InspectionsSiteIDRoute = InspectionsSiteIDImport.update({
  id: '/inspections/$siteID',
  path: '/inspections/$siteID',
  getParentRoute: () => rootRoute,
} as any)

const HealthPlansSiteIDRoute = HealthPlansSiteIDImport.update({
  id: '/health-plans/$siteID',
  path: '/health-plans/$siteID',
  getParentRoute: () => rootRoute,
} as any)

const ForgingEntryIDRoute = ForgingEntryIDImport.update({
  id: '/forging/$entryID',
  path: '/forging/$entryID',
  getParentRoute: () => rootRoute,
} as any)

const ExtensionsOrgIDRoute = ExtensionsOrgIDImport.update({
  id: '/extensions/$orgID',
  path: '/extensions/$orgID',
  getParentRoute: () => rootRoute,
} as any)

const ExplorerSiteIDRoute = ExplorerSiteIDImport.update({
  id: '/$siteID',
  path: '/$siteID',
  getParentRoute: () => ExplorerRouteRoute,
} as any)

const EquipmentEquipmentIDRoute = EquipmentEquipmentIDImport.update({
  id: '/equipment/$equipmentID',
  path: '/equipment/$equipmentID',
  getParentRoute: () => rootRoute,
} as any)

const DrilldownExplorationSiteIDRoute = DrilldownExplorationSiteIDImport.update(
  {
    id: '/drilldown-exploration/$siteID',
    path: '/drilldown-exploration/$siteID',
    getParentRoute: () => rootRoute,
  } as any,
)

const DetailsEntryIDRoute = DetailsEntryIDImport.update({
  id: '/details/$entryID',
  path: '/details/$entryID',
  getParentRoute: () => rootRoute,
} as any)

const AssemblyAssemblyIDRoute = AssemblyAssemblyIDImport.update({
  id: '/assembly/$assemblyID',
  path: '/assembly/$assemblyID',
  getParentRoute: () => rootRoute,
} as any)

const AdminUsersRoute = AdminUsersImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRoute,
} as any)

const RedirectsLandingRoute = RedirectsLandingImport.update({
  id: '/_redirects/landing',
  path: '/landing',
  getParentRoute: () => rootRoute,
} as any)

const WalkdownsSiteIDIndexRoute = WalkdownsSiteIDIndexImport.update({
  id: '/$siteID/',
  path: '/$siteID/',
  getParentRoute: () => WalkdownsRouteRoute,
} as any)

const ProcessFlowsSiteIDIndexRoute = ProcessFlowsSiteIDIndexImport.update({
  id: '/process-flows/$siteID/',
  path: '/process-flows/$siteID/',
  getParentRoute: () => rootRoute,
} as any)

const PointCloudSiteIDIndexRoute = PointCloudSiteIDIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PointCloudSiteIDRoute,
} as any)

const PartsSiteIDIndexRoute = PartsSiteIDIndexImport.update({
  id: '/$siteID/',
  path: '/$siteID/',
  getParentRoute: () => PartsRouteRoute,
} as any)

const AssetsSiteIDIndexRoute = AssetsSiteIDIndexImport.update({
  id: '/$siteID/',
  path: '/$siteID/',
  getParentRoute: () => AssetsRouteRoute,
} as any)

const AssetAssessmentSiteIDIndexRoute = AssetAssessmentSiteIDIndexImport.update(
  {
    id: '/asset-assessment/$siteID/',
    path: '/asset-assessment/$siteID/',
    getParentRoute: () => rootRoute,
  } as any,
)

const WalkdownsSiteIDWalkdownIdRoute = WalkdownsSiteIDWalkdownIdImport.update({
  id: '/$siteID/$walkdownId',
  path: '/$siteID/$walkdownId',
  getParentRoute: () => WalkdownsRouteRoute,
} as any)

const ViewerUnitIDInspectionRoute = ViewerUnitIDInspectionImport.update({
  id: '/$unitID/inspection',
  path: '/$unitID/inspection',
  getParentRoute: () => ViewerRouteRoute,
} as any)

const ViewerUnitIDConfigurationRoute = ViewerUnitIDConfigurationImport.update({
  id: '/$unitID/configuration',
  path: '/$unitID/configuration',
  getParentRoute: () => ViewerRouteRoute,
} as any)

const ProcessFlowsSiteIDDiagramIDRoute =
  ProcessFlowsSiteIDDiagramIDImport.update({
    id: '/process-flows/$siteID/$diagramID',
    path: '/process-flows/$siteID/$diagramID',
    getParentRoute: () => rootRoute,
  } as any)

const PointCloudSiteIDPointCloudOrSceneIDRoute =
  PointCloudSiteIDPointCloudOrSceneIDImport.update({
    id: '/$pointCloudOrSceneID',
    path: '/$pointCloudOrSceneID',
    getParentRoute: () => PointCloudSiteIDRoute,
  } as any)

const OrganizationOrgIDSiteRoute = OrganizationOrgIDSiteImport.update({
  id: '/organization_/$orgID/site',
  path: '/organization/$orgID/site',
  getParentRoute: () => rootRoute,
} as any)

const AssetsSiteIDUnitIDRoute = AssetsSiteIDUnitIDImport.update({
  id: '/$siteID/$unitID',
  path: '/$siteID/$unitID',
  getParentRoute: () => AssetsRouteRoute,
} as any)

const AssetLensSiteIDUnitIDRoute = AssetLensSiteIDUnitIDImport.update({
  id: '/asset-lens/$siteID/$unitID',
  path: '/asset-lens/$siteID/$unitID',
  getParentRoute: () => rootRoute,
} as any)

const AssetAssessmentSiteIDUnitIDRoute =
  AssetAssessmentSiteIDUnitIDImport.update({
    id: '/asset-assessment/$siteID/$unitID',
    path: '/asset-assessment/$siteID/$unitID',
    getParentRoute: () => rootRoute,
  } as any)

const RedirectsSiteViewSiteIDRoute = RedirectsSiteViewSiteIDImport.update({
  id: '/_redirects/site-view/$siteID',
  path: '/site-view/$siteID',
  getParentRoute: () => rootRoute,
} as any)

const OrganizationOrgIDSiteSiteIDRoute =
  OrganizationOrgIDSiteSiteIDImport.update({
    id: '/$siteID',
    path: '/$siteID',
    getParentRoute: () => OrganizationOrgIDSiteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/assets': {
      id: '/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AssetsRouteImport
      parentRoute: typeof rootRoute
    }
    '/explorer': {
      id: '/explorer'
      path: '/explorer'
      fullPath: '/explorer'
      preLoaderRoute: typeof ExplorerRouteImport
      parentRoute: typeof rootRoute
    }
    '/parts': {
      id: '/parts'
      path: '/parts'
      fullPath: '/parts'
      preLoaderRoute: typeof PartsRouteImport
      parentRoute: typeof rootRoute
    }
    '/viewer': {
      id: '/viewer'
      path: '/viewer'
      fullPath: '/viewer'
      preLoaderRoute: typeof ViewerRouteImport
      parentRoute: typeof rootRoute
    }
    '/walkdowns': {
      id: '/walkdowns'
      path: '/walkdowns'
      fullPath: '/walkdowns'
      preLoaderRoute: typeof WalkdownsRouteImport
      parentRoute: typeof rootRoute
    }
    '/_fallback': {
      id: '/_fallback'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof FallbackImport
      parentRoute: typeof rootRoute
    }
    '/health-check': {
      id: '/health-check'
      path: '/health-check'
      fullPath: '/health-check'
      preLoaderRoute: typeof HealthCheckImport
      parentRoute: typeof rootRoute
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryImport
      parentRoute: typeof rootRoute
    }
    '/jobs': {
      id: '/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof JobsImport
      parentRoute: typeof rootRoute
    }
    '/organization': {
      id: '/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof OrganizationImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyImport
      parentRoute: typeof rootRoute
    }
    '/_redirects/landing': {
      id: '/_redirects/landing'
      path: '/landing'
      fullPath: '/landing'
      preLoaderRoute: typeof RedirectsLandingImport
      parentRoute: typeof rootRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersImport
      parentRoute: typeof rootRoute
    }
    '/assembly/$assemblyID': {
      id: '/assembly/$assemblyID'
      path: '/assembly/$assemblyID'
      fullPath: '/assembly/$assemblyID'
      preLoaderRoute: typeof AssemblyAssemblyIDImport
      parentRoute: typeof rootRoute
    }
    '/details/$entryID': {
      id: '/details/$entryID'
      path: '/details/$entryID'
      fullPath: '/details/$entryID'
      preLoaderRoute: typeof DetailsEntryIDImport
      parentRoute: typeof rootRoute
    }
    '/drilldown-exploration/$siteID': {
      id: '/drilldown-exploration/$siteID'
      path: '/drilldown-exploration/$siteID'
      fullPath: '/drilldown-exploration/$siteID'
      preLoaderRoute: typeof DrilldownExplorationSiteIDImport
      parentRoute: typeof rootRoute
    }
    '/equipment/$equipmentID': {
      id: '/equipment/$equipmentID'
      path: '/equipment/$equipmentID'
      fullPath: '/equipment/$equipmentID'
      preLoaderRoute: typeof EquipmentEquipmentIDImport
      parentRoute: typeof rootRoute
    }
    '/explorer/$siteID': {
      id: '/explorer/$siteID'
      path: '/$siteID'
      fullPath: '/explorer/$siteID'
      preLoaderRoute: typeof ExplorerSiteIDImport
      parentRoute: typeof ExplorerRouteImport
    }
    '/extensions/$orgID': {
      id: '/extensions/$orgID'
      path: '/extensions/$orgID'
      fullPath: '/extensions/$orgID'
      preLoaderRoute: typeof ExtensionsOrgIDImport
      parentRoute: typeof rootRoute
    }
    '/forging/$entryID': {
      id: '/forging/$entryID'
      path: '/forging/$entryID'
      fullPath: '/forging/$entryID'
      preLoaderRoute: typeof ForgingEntryIDImport
      parentRoute: typeof rootRoute
    }
    '/health-plans/$siteID': {
      id: '/health-plans/$siteID'
      path: '/health-plans/$siteID'
      fullPath: '/health-plans/$siteID'
      preLoaderRoute: typeof HealthPlansSiteIDImport
      parentRoute: typeof rootRoute
    }
    '/inspections/$siteID': {
      id: '/inspections/$siteID'
      path: '/inspections/$siteID'
      fullPath: '/inspections/$siteID'
      preLoaderRoute: typeof InspectionsSiteIDImport
      parentRoute: typeof rootRoute
    }
    '/job/$siteID': {
      id: '/job/$siteID'
      path: '/job/$siteID'
      fullPath: '/job/$siteID'
      preLoaderRoute: typeof JobSiteIDImport
      parentRoute: typeof rootRoute
    }
    '/maximo/$siteID': {
      id: '/maximo/$siteID'
      path: '/maximo/$siteID'
      fullPath: '/maximo/$siteID'
      preLoaderRoute: typeof MaximoSiteIDImport
      parentRoute: typeof rootRoute
    }
    '/no-sites/$orgID': {
      id: '/no-sites/$orgID'
      path: '/no-sites/$orgID'
      fullPath: '/no-sites/$orgID'
      preLoaderRoute: typeof NoSitesOrgIDImport
      parentRoute: typeof rootRoute
    }
    '/organization/$orgID': {
      id: '/organization/$orgID'
      path: '/$orgID'
      fullPath: '/organization/$orgID'
      preLoaderRoute: typeof OrganizationOrgIDImport
      parentRoute: typeof OrganizationImport
    }
    '/overview/$siteID': {
      id: '/overview/$siteID'
      path: '/overview/$siteID'
      fullPath: '/overview/$siteID'
      preLoaderRoute: typeof OverviewSiteIDImport
      parentRoute: typeof rootRoute
    }
    '/point-cloud/$siteID': {
      id: '/point-cloud/$siteID'
      path: '/point-cloud/$siteID'
      fullPath: '/point-cloud/$siteID'
      preLoaderRoute: typeof PointCloudSiteIDImport
      parentRoute: typeof rootRoute
    }
    '/scheduling/$siteID': {
      id: '/scheduling/$siteID'
      path: '/scheduling/$siteID'
      fullPath: '/scheduling/$siteID'
      preLoaderRoute: typeof SchedulingSiteIDImport
      parentRoute: typeof rootRoute
    }
    '/sub-assembly/$subAssemblyID': {
      id: '/sub-assembly/$subAssemblyID'
      path: '/sub-assembly/$subAssemblyID'
      fullPath: '/sub-assembly/$subAssemblyID'
      preLoaderRoute: typeof SubAssemblySubAssemblyIDImport
      parentRoute: typeof rootRoute
    }
    '/users/$orgID': {
      id: '/users/$orgID'
      path: '/users/$orgID'
      fullPath: '/users/$orgID'
      preLoaderRoute: typeof UsersOrgIDImport
      parentRoute: typeof rootRoute
    }
    '/work-order/$workOrderID': {
      id: '/work-order/$workOrderID'
      path: '/work-order/$workOrderID'
      fullPath: '/work-order/$workOrderID'
      preLoaderRoute: typeof WorkOrderWorkOrderIDImport
      parentRoute: typeof rootRoute
    }
    '/_redirects/': {
      id: '/_redirects/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof RedirectsIndexImport
      parentRoute: typeof rootRoute
    }
    '/explorer/': {
      id: '/explorer/'
      path: '/'
      fullPath: '/explorer/'
      preLoaderRoute: typeof ExplorerIndexImport
      parentRoute: typeof ExplorerRouteImport
    }
    '/_redirects/site-view/$siteID': {
      id: '/_redirects/site-view/$siteID'
      path: '/site-view/$siteID'
      fullPath: '/site-view/$siteID'
      preLoaderRoute: typeof RedirectsSiteViewSiteIDImport
      parentRoute: typeof rootRoute
    }
    '/asset-assessment/$siteID/$unitID': {
      id: '/asset-assessment/$siteID/$unitID'
      path: '/asset-assessment/$siteID/$unitID'
      fullPath: '/asset-assessment/$siteID/$unitID'
      preLoaderRoute: typeof AssetAssessmentSiteIDUnitIDImport
      parentRoute: typeof rootRoute
    }
    '/asset-lens/$siteID/$unitID': {
      id: '/asset-lens/$siteID/$unitID'
      path: '/asset-lens/$siteID/$unitID'
      fullPath: '/asset-lens/$siteID/$unitID'
      preLoaderRoute: typeof AssetLensSiteIDUnitIDImport
      parentRoute: typeof rootRoute
    }
    '/assets/$siteID/$unitID': {
      id: '/assets/$siteID/$unitID'
      path: '/$siteID/$unitID'
      fullPath: '/assets/$siteID/$unitID'
      preLoaderRoute: typeof AssetsSiteIDUnitIDImport
      parentRoute: typeof AssetsRouteImport
    }
    '/organization_/$orgID/site': {
      id: '/organization_/$orgID/site'
      path: '/organization/$orgID/site'
      fullPath: '/organization/$orgID/site'
      preLoaderRoute: typeof OrganizationOrgIDSiteImport
      parentRoute: typeof rootRoute
    }
    '/point-cloud/$siteID/$pointCloudOrSceneID': {
      id: '/point-cloud/$siteID/$pointCloudOrSceneID'
      path: '/$pointCloudOrSceneID'
      fullPath: '/point-cloud/$siteID/$pointCloudOrSceneID'
      preLoaderRoute: typeof PointCloudSiteIDPointCloudOrSceneIDImport
      parentRoute: typeof PointCloudSiteIDImport
    }
    '/process-flows/$siteID/$diagramID': {
      id: '/process-flows/$siteID/$diagramID'
      path: '/process-flows/$siteID/$diagramID'
      fullPath: '/process-flows/$siteID/$diagramID'
      preLoaderRoute: typeof ProcessFlowsSiteIDDiagramIDImport
      parentRoute: typeof rootRoute
    }
    '/viewer/$unitID/configuration': {
      id: '/viewer/$unitID/configuration'
      path: '/$unitID/configuration'
      fullPath: '/viewer/$unitID/configuration'
      preLoaderRoute: typeof ViewerUnitIDConfigurationImport
      parentRoute: typeof ViewerRouteImport
    }
    '/viewer/$unitID/inspection': {
      id: '/viewer/$unitID/inspection'
      path: '/$unitID/inspection'
      fullPath: '/viewer/$unitID/inspection'
      preLoaderRoute: typeof ViewerUnitIDInspectionImport
      parentRoute: typeof ViewerRouteImport
    }
    '/walkdowns/$siteID/$walkdownId': {
      id: '/walkdowns/$siteID/$walkdownId'
      path: '/$siteID/$walkdownId'
      fullPath: '/walkdowns/$siteID/$walkdownId'
      preLoaderRoute: typeof WalkdownsSiteIDWalkdownIdImport
      parentRoute: typeof WalkdownsRouteImport
    }
    '/asset-assessment/$siteID/': {
      id: '/asset-assessment/$siteID/'
      path: '/asset-assessment/$siteID'
      fullPath: '/asset-assessment/$siteID'
      preLoaderRoute: typeof AssetAssessmentSiteIDIndexImport
      parentRoute: typeof rootRoute
    }
    '/assets/$siteID/': {
      id: '/assets/$siteID/'
      path: '/$siteID'
      fullPath: '/assets/$siteID'
      preLoaderRoute: typeof AssetsSiteIDIndexImport
      parentRoute: typeof AssetsRouteImport
    }
    '/parts/$siteID/': {
      id: '/parts/$siteID/'
      path: '/$siteID'
      fullPath: '/parts/$siteID'
      preLoaderRoute: typeof PartsSiteIDIndexImport
      parentRoute: typeof PartsRouteImport
    }
    '/point-cloud/$siteID/': {
      id: '/point-cloud/$siteID/'
      path: '/'
      fullPath: '/point-cloud/$siteID/'
      preLoaderRoute: typeof PointCloudSiteIDIndexImport
      parentRoute: typeof PointCloudSiteIDImport
    }
    '/process-flows/$siteID/': {
      id: '/process-flows/$siteID/'
      path: '/process-flows/$siteID'
      fullPath: '/process-flows/$siteID'
      preLoaderRoute: typeof ProcessFlowsSiteIDIndexImport
      parentRoute: typeof rootRoute
    }
    '/walkdowns/$siteID/': {
      id: '/walkdowns/$siteID/'
      path: '/$siteID'
      fullPath: '/walkdowns/$siteID'
      preLoaderRoute: typeof WalkdownsSiteIDIndexImport
      parentRoute: typeof WalkdownsRouteImport
    }
    '/organization_/$orgID/site/$siteID': {
      id: '/organization_/$orgID/site/$siteID'
      path: '/$siteID'
      fullPath: '/organization/$orgID/site/$siteID'
      preLoaderRoute: typeof OrganizationOrgIDSiteSiteIDImport
      parentRoute: typeof OrganizationOrgIDSiteImport
    }
  }
}

// Create and export the route tree

interface AssetsRouteRouteChildren {
  AssetsSiteIDUnitIDRoute: typeof AssetsSiteIDUnitIDRoute
  AssetsSiteIDIndexRoute: typeof AssetsSiteIDIndexRoute
}

const AssetsRouteRouteChildren: AssetsRouteRouteChildren = {
  AssetsSiteIDUnitIDRoute: AssetsSiteIDUnitIDRoute,
  AssetsSiteIDIndexRoute: AssetsSiteIDIndexRoute,
}

const AssetsRouteRouteWithChildren = AssetsRouteRoute._addFileChildren(
  AssetsRouteRouteChildren,
)

interface ExplorerRouteRouteChildren {
  ExplorerSiteIDRoute: typeof ExplorerSiteIDRoute
  ExplorerIndexRoute: typeof ExplorerIndexRoute
}

const ExplorerRouteRouteChildren: ExplorerRouteRouteChildren = {
  ExplorerSiteIDRoute: ExplorerSiteIDRoute,
  ExplorerIndexRoute: ExplorerIndexRoute,
}

const ExplorerRouteRouteWithChildren = ExplorerRouteRoute._addFileChildren(
  ExplorerRouteRouteChildren,
)

interface PartsRouteRouteChildren {
  PartsSiteIDIndexRoute: typeof PartsSiteIDIndexRoute
}

const PartsRouteRouteChildren: PartsRouteRouteChildren = {
  PartsSiteIDIndexRoute: PartsSiteIDIndexRoute,
}

const PartsRouteRouteWithChildren = PartsRouteRoute._addFileChildren(
  PartsRouteRouteChildren,
)

interface ViewerRouteRouteChildren {
  ViewerUnitIDConfigurationRoute: typeof ViewerUnitIDConfigurationRoute
  ViewerUnitIDInspectionRoute: typeof ViewerUnitIDInspectionRoute
}

const ViewerRouteRouteChildren: ViewerRouteRouteChildren = {
  ViewerUnitIDConfigurationRoute: ViewerUnitIDConfigurationRoute,
  ViewerUnitIDInspectionRoute: ViewerUnitIDInspectionRoute,
}

const ViewerRouteRouteWithChildren = ViewerRouteRoute._addFileChildren(
  ViewerRouteRouteChildren,
)

interface WalkdownsRouteRouteChildren {
  WalkdownsSiteIDWalkdownIdRoute: typeof WalkdownsSiteIDWalkdownIdRoute
  WalkdownsSiteIDIndexRoute: typeof WalkdownsSiteIDIndexRoute
}

const WalkdownsRouteRouteChildren: WalkdownsRouteRouteChildren = {
  WalkdownsSiteIDWalkdownIdRoute: WalkdownsSiteIDWalkdownIdRoute,
  WalkdownsSiteIDIndexRoute: WalkdownsSiteIDIndexRoute,
}

const WalkdownsRouteRouteWithChildren = WalkdownsRouteRoute._addFileChildren(
  WalkdownsRouteRouteChildren,
)

interface OrganizationRouteChildren {
  OrganizationOrgIDRoute: typeof OrganizationOrgIDRoute
}

const OrganizationRouteChildren: OrganizationRouteChildren = {
  OrganizationOrgIDRoute: OrganizationOrgIDRoute,
}

const OrganizationRouteWithChildren = OrganizationRoute._addFileChildren(
  OrganizationRouteChildren,
)

interface PointCloudSiteIDRouteChildren {
  PointCloudSiteIDPointCloudOrSceneIDRoute: typeof PointCloudSiteIDPointCloudOrSceneIDRoute
  PointCloudSiteIDIndexRoute: typeof PointCloudSiteIDIndexRoute
}

const PointCloudSiteIDRouteChildren: PointCloudSiteIDRouteChildren = {
  PointCloudSiteIDPointCloudOrSceneIDRoute:
    PointCloudSiteIDPointCloudOrSceneIDRoute,
  PointCloudSiteIDIndexRoute: PointCloudSiteIDIndexRoute,
}

const PointCloudSiteIDRouteWithChildren =
  PointCloudSiteIDRoute._addFileChildren(PointCloudSiteIDRouteChildren)

interface OrganizationOrgIDSiteRouteChildren {
  OrganizationOrgIDSiteSiteIDRoute: typeof OrganizationOrgIDSiteSiteIDRoute
}

const OrganizationOrgIDSiteRouteChildren: OrganizationOrgIDSiteRouteChildren = {
  OrganizationOrgIDSiteSiteIDRoute: OrganizationOrgIDSiteSiteIDRoute,
}

const OrganizationOrgIDSiteRouteWithChildren =
  OrganizationOrgIDSiteRoute._addFileChildren(
    OrganizationOrgIDSiteRouteChildren,
  )

export interface FileRoutesByFullPath {
  '/assets': typeof AssetsRouteRouteWithChildren
  '/explorer': typeof ExplorerRouteRouteWithChildren
  '/parts': typeof PartsRouteRouteWithChildren
  '/viewer': typeof ViewerRouteRouteWithChildren
  '/walkdowns': typeof WalkdownsRouteRouteWithChildren
  '': typeof FallbackRoute
  '/health-check': typeof HealthCheckRoute
  '/inventory': typeof InventoryRoute
  '/jobs': typeof JobsRoute
  '/organization': typeof OrganizationRouteWithChildren
  '/about': typeof AboutLazyRoute
  '/landing': typeof RedirectsLandingRoute
  '/admin/users': typeof AdminUsersRoute
  '/assembly/$assemblyID': typeof AssemblyAssemblyIDRoute
  '/details/$entryID': typeof DetailsEntryIDRoute
  '/drilldown-exploration/$siteID': typeof DrilldownExplorationSiteIDRoute
  '/equipment/$equipmentID': typeof EquipmentEquipmentIDRoute
  '/explorer/$siteID': typeof ExplorerSiteIDRoute
  '/extensions/$orgID': typeof ExtensionsOrgIDRoute
  '/forging/$entryID': typeof ForgingEntryIDRoute
  '/health-plans/$siteID': typeof HealthPlansSiteIDRoute
  '/inspections/$siteID': typeof InspectionsSiteIDRoute
  '/job/$siteID': typeof JobSiteIDRoute
  '/maximo/$siteID': typeof MaximoSiteIDRoute
  '/no-sites/$orgID': typeof NoSitesOrgIDRoute
  '/organization/$orgID': typeof OrganizationOrgIDRoute
  '/overview/$siteID': typeof OverviewSiteIDRoute
  '/point-cloud/$siteID': typeof PointCloudSiteIDRouteWithChildren
  '/scheduling/$siteID': typeof SchedulingSiteIDRoute
  '/sub-assembly/$subAssemblyID': typeof SubAssemblySubAssemblyIDRoute
  '/users/$orgID': typeof UsersOrgIDRoute
  '/work-order/$workOrderID': typeof WorkOrderWorkOrderIDRoute
  '/': typeof RedirectsIndexRoute
  '/explorer/': typeof ExplorerIndexRoute
  '/site-view/$siteID': typeof RedirectsSiteViewSiteIDRoute
  '/asset-assessment/$siteID/$unitID': typeof AssetAssessmentSiteIDUnitIDRoute
  '/asset-lens/$siteID/$unitID': typeof AssetLensSiteIDUnitIDRoute
  '/assets/$siteID/$unitID': typeof AssetsSiteIDUnitIDRoute
  '/organization/$orgID/site': typeof OrganizationOrgIDSiteRouteWithChildren
  '/point-cloud/$siteID/$pointCloudOrSceneID': typeof PointCloudSiteIDPointCloudOrSceneIDRoute
  '/process-flows/$siteID/$diagramID': typeof ProcessFlowsSiteIDDiagramIDRoute
  '/viewer/$unitID/configuration': typeof ViewerUnitIDConfigurationRoute
  '/viewer/$unitID/inspection': typeof ViewerUnitIDInspectionRoute
  '/walkdowns/$siteID/$walkdownId': typeof WalkdownsSiteIDWalkdownIdRoute
  '/asset-assessment/$siteID': typeof AssetAssessmentSiteIDIndexRoute
  '/assets/$siteID': typeof AssetsSiteIDIndexRoute
  '/parts/$siteID': typeof PartsSiteIDIndexRoute
  '/point-cloud/$siteID/': typeof PointCloudSiteIDIndexRoute
  '/process-flows/$siteID': typeof ProcessFlowsSiteIDIndexRoute
  '/walkdowns/$siteID': typeof WalkdownsSiteIDIndexRoute
  '/organization/$orgID/site/$siteID': typeof OrganizationOrgIDSiteSiteIDRoute
}

export interface FileRoutesByTo {
  '/assets': typeof AssetsRouteRouteWithChildren
  '/parts': typeof PartsRouteRouteWithChildren
  '/viewer': typeof ViewerRouteRouteWithChildren
  '/walkdowns': typeof WalkdownsRouteRouteWithChildren
  '': typeof FallbackRoute
  '/health-check': typeof HealthCheckRoute
  '/inventory': typeof InventoryRoute
  '/jobs': typeof JobsRoute
  '/organization': typeof OrganizationRouteWithChildren
  '/about': typeof AboutLazyRoute
  '/landing': typeof RedirectsLandingRoute
  '/admin/users': typeof AdminUsersRoute
  '/assembly/$assemblyID': typeof AssemblyAssemblyIDRoute
  '/details/$entryID': typeof DetailsEntryIDRoute
  '/drilldown-exploration/$siteID': typeof DrilldownExplorationSiteIDRoute
  '/equipment/$equipmentID': typeof EquipmentEquipmentIDRoute
  '/explorer/$siteID': typeof ExplorerSiteIDRoute
  '/extensions/$orgID': typeof ExtensionsOrgIDRoute
  '/forging/$entryID': typeof ForgingEntryIDRoute
  '/health-plans/$siteID': typeof HealthPlansSiteIDRoute
  '/inspections/$siteID': typeof InspectionsSiteIDRoute
  '/job/$siteID': typeof JobSiteIDRoute
  '/maximo/$siteID': typeof MaximoSiteIDRoute
  '/no-sites/$orgID': typeof NoSitesOrgIDRoute
  '/organization/$orgID': typeof OrganizationOrgIDRoute
  '/overview/$siteID': typeof OverviewSiteIDRoute
  '/scheduling/$siteID': typeof SchedulingSiteIDRoute
  '/sub-assembly/$subAssemblyID': typeof SubAssemblySubAssemblyIDRoute
  '/users/$orgID': typeof UsersOrgIDRoute
  '/work-order/$workOrderID': typeof WorkOrderWorkOrderIDRoute
  '/': typeof RedirectsIndexRoute
  '/explorer': typeof ExplorerIndexRoute
  '/site-view/$siteID': typeof RedirectsSiteViewSiteIDRoute
  '/asset-assessment/$siteID/$unitID': typeof AssetAssessmentSiteIDUnitIDRoute
  '/asset-lens/$siteID/$unitID': typeof AssetLensSiteIDUnitIDRoute
  '/assets/$siteID/$unitID': typeof AssetsSiteIDUnitIDRoute
  '/organization/$orgID/site': typeof OrganizationOrgIDSiteRouteWithChildren
  '/point-cloud/$siteID/$pointCloudOrSceneID': typeof PointCloudSiteIDPointCloudOrSceneIDRoute
  '/process-flows/$siteID/$diagramID': typeof ProcessFlowsSiteIDDiagramIDRoute
  '/viewer/$unitID/configuration': typeof ViewerUnitIDConfigurationRoute
  '/viewer/$unitID/inspection': typeof ViewerUnitIDInspectionRoute
  '/walkdowns/$siteID/$walkdownId': typeof WalkdownsSiteIDWalkdownIdRoute
  '/asset-assessment/$siteID': typeof AssetAssessmentSiteIDIndexRoute
  '/assets/$siteID': typeof AssetsSiteIDIndexRoute
  '/parts/$siteID': typeof PartsSiteIDIndexRoute
  '/point-cloud/$siteID': typeof PointCloudSiteIDIndexRoute
  '/process-flows/$siteID': typeof ProcessFlowsSiteIDIndexRoute
  '/walkdowns/$siteID': typeof WalkdownsSiteIDIndexRoute
  '/organization/$orgID/site/$siteID': typeof OrganizationOrgIDSiteSiteIDRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/assets': typeof AssetsRouteRouteWithChildren
  '/explorer': typeof ExplorerRouteRouteWithChildren
  '/parts': typeof PartsRouteRouteWithChildren
  '/viewer': typeof ViewerRouteRouteWithChildren
  '/walkdowns': typeof WalkdownsRouteRouteWithChildren
  '/_fallback': typeof FallbackRoute
  '/health-check': typeof HealthCheckRoute
  '/inventory': typeof InventoryRoute
  '/jobs': typeof JobsRoute
  '/organization': typeof OrganizationRouteWithChildren
  '/about': typeof AboutLazyRoute
  '/_redirects/landing': typeof RedirectsLandingRoute
  '/admin/users': typeof AdminUsersRoute
  '/assembly/$assemblyID': typeof AssemblyAssemblyIDRoute
  '/details/$entryID': typeof DetailsEntryIDRoute
  '/drilldown-exploration/$siteID': typeof DrilldownExplorationSiteIDRoute
  '/equipment/$equipmentID': typeof EquipmentEquipmentIDRoute
  '/explorer/$siteID': typeof ExplorerSiteIDRoute
  '/extensions/$orgID': typeof ExtensionsOrgIDRoute
  '/forging/$entryID': typeof ForgingEntryIDRoute
  '/health-plans/$siteID': typeof HealthPlansSiteIDRoute
  '/inspections/$siteID': typeof InspectionsSiteIDRoute
  '/job/$siteID': typeof JobSiteIDRoute
  '/maximo/$siteID': typeof MaximoSiteIDRoute
  '/no-sites/$orgID': typeof NoSitesOrgIDRoute
  '/organization/$orgID': typeof OrganizationOrgIDRoute
  '/overview/$siteID': typeof OverviewSiteIDRoute
  '/point-cloud/$siteID': typeof PointCloudSiteIDRouteWithChildren
  '/scheduling/$siteID': typeof SchedulingSiteIDRoute
  '/sub-assembly/$subAssemblyID': typeof SubAssemblySubAssemblyIDRoute
  '/users/$orgID': typeof UsersOrgIDRoute
  '/work-order/$workOrderID': typeof WorkOrderWorkOrderIDRoute
  '/_redirects/': typeof RedirectsIndexRoute
  '/explorer/': typeof ExplorerIndexRoute
  '/_redirects/site-view/$siteID': typeof RedirectsSiteViewSiteIDRoute
  '/asset-assessment/$siteID/$unitID': typeof AssetAssessmentSiteIDUnitIDRoute
  '/asset-lens/$siteID/$unitID': typeof AssetLensSiteIDUnitIDRoute
  '/assets/$siteID/$unitID': typeof AssetsSiteIDUnitIDRoute
  '/organization_/$orgID/site': typeof OrganizationOrgIDSiteRouteWithChildren
  '/point-cloud/$siteID/$pointCloudOrSceneID': typeof PointCloudSiteIDPointCloudOrSceneIDRoute
  '/process-flows/$siteID/$diagramID': typeof ProcessFlowsSiteIDDiagramIDRoute
  '/viewer/$unitID/configuration': typeof ViewerUnitIDConfigurationRoute
  '/viewer/$unitID/inspection': typeof ViewerUnitIDInspectionRoute
  '/walkdowns/$siteID/$walkdownId': typeof WalkdownsSiteIDWalkdownIdRoute
  '/asset-assessment/$siteID/': typeof AssetAssessmentSiteIDIndexRoute
  '/assets/$siteID/': typeof AssetsSiteIDIndexRoute
  '/parts/$siteID/': typeof PartsSiteIDIndexRoute
  '/point-cloud/$siteID/': typeof PointCloudSiteIDIndexRoute
  '/process-flows/$siteID/': typeof ProcessFlowsSiteIDIndexRoute
  '/walkdowns/$siteID/': typeof WalkdownsSiteIDIndexRoute
  '/organization_/$orgID/site/$siteID': typeof OrganizationOrgIDSiteSiteIDRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/assets'
    | '/explorer'
    | '/parts'
    | '/viewer'
    | '/walkdowns'
    | ''
    | '/health-check'
    | '/inventory'
    | '/jobs'
    | '/organization'
    | '/about'
    | '/landing'
    | '/admin/users'
    | '/assembly/$assemblyID'
    | '/details/$entryID'
    | '/drilldown-exploration/$siteID'
    | '/equipment/$equipmentID'
    | '/explorer/$siteID'
    | '/extensions/$orgID'
    | '/forging/$entryID'
    | '/health-plans/$siteID'
    | '/inspections/$siteID'
    | '/job/$siteID'
    | '/maximo/$siteID'
    | '/no-sites/$orgID'
    | '/organization/$orgID'
    | '/overview/$siteID'
    | '/point-cloud/$siteID'
    | '/scheduling/$siteID'
    | '/sub-assembly/$subAssemblyID'
    | '/users/$orgID'
    | '/work-order/$workOrderID'
    | '/'
    | '/explorer/'
    | '/site-view/$siteID'
    | '/asset-assessment/$siteID/$unitID'
    | '/asset-lens/$siteID/$unitID'
    | '/assets/$siteID/$unitID'
    | '/organization/$orgID/site'
    | '/point-cloud/$siteID/$pointCloudOrSceneID'
    | '/process-flows/$siteID/$diagramID'
    | '/viewer/$unitID/configuration'
    | '/viewer/$unitID/inspection'
    | '/walkdowns/$siteID/$walkdownId'
    | '/asset-assessment/$siteID'
    | '/assets/$siteID'
    | '/parts/$siteID'
    | '/point-cloud/$siteID/'
    | '/process-flows/$siteID'
    | '/walkdowns/$siteID'
    | '/organization/$orgID/site/$siteID'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/assets'
    | '/parts'
    | '/viewer'
    | '/walkdowns'
    | ''
    | '/health-check'
    | '/inventory'
    | '/jobs'
    | '/organization'
    | '/about'
    | '/landing'
    | '/admin/users'
    | '/assembly/$assemblyID'
    | '/details/$entryID'
    | '/drilldown-exploration/$siteID'
    | '/equipment/$equipmentID'
    | '/explorer/$siteID'
    | '/extensions/$orgID'
    | '/forging/$entryID'
    | '/health-plans/$siteID'
    | '/inspections/$siteID'
    | '/job/$siteID'
    | '/maximo/$siteID'
    | '/no-sites/$orgID'
    | '/organization/$orgID'
    | '/overview/$siteID'
    | '/scheduling/$siteID'
    | '/sub-assembly/$subAssemblyID'
    | '/users/$orgID'
    | '/work-order/$workOrderID'
    | '/'
    | '/explorer'
    | '/site-view/$siteID'
    | '/asset-assessment/$siteID/$unitID'
    | '/asset-lens/$siteID/$unitID'
    | '/assets/$siteID/$unitID'
    | '/organization/$orgID/site'
    | '/point-cloud/$siteID/$pointCloudOrSceneID'
    | '/process-flows/$siteID/$diagramID'
    | '/viewer/$unitID/configuration'
    | '/viewer/$unitID/inspection'
    | '/walkdowns/$siteID/$walkdownId'
    | '/asset-assessment/$siteID'
    | '/assets/$siteID'
    | '/parts/$siteID'
    | '/point-cloud/$siteID'
    | '/process-flows/$siteID'
    | '/walkdowns/$siteID'
    | '/organization/$orgID/site/$siteID'
  id:
    | '__root__'
    | '/assets'
    | '/explorer'
    | '/parts'
    | '/viewer'
    | '/walkdowns'
    | '/_fallback'
    | '/health-check'
    | '/inventory'
    | '/jobs'
    | '/organization'
    | '/about'
    | '/_redirects/landing'
    | '/admin/users'
    | '/assembly/$assemblyID'
    | '/details/$entryID'
    | '/drilldown-exploration/$siteID'
    | '/equipment/$equipmentID'
    | '/explorer/$siteID'
    | '/extensions/$orgID'
    | '/forging/$entryID'
    | '/health-plans/$siteID'
    | '/inspections/$siteID'
    | '/job/$siteID'
    | '/maximo/$siteID'
    | '/no-sites/$orgID'
    | '/organization/$orgID'
    | '/overview/$siteID'
    | '/point-cloud/$siteID'
    | '/scheduling/$siteID'
    | '/sub-assembly/$subAssemblyID'
    | '/users/$orgID'
    | '/work-order/$workOrderID'
    | '/_redirects/'
    | '/explorer/'
    | '/_redirects/site-view/$siteID'
    | '/asset-assessment/$siteID/$unitID'
    | '/asset-lens/$siteID/$unitID'
    | '/assets/$siteID/$unitID'
    | '/organization_/$orgID/site'
    | '/point-cloud/$siteID/$pointCloudOrSceneID'
    | '/process-flows/$siteID/$diagramID'
    | '/viewer/$unitID/configuration'
    | '/viewer/$unitID/inspection'
    | '/walkdowns/$siteID/$walkdownId'
    | '/asset-assessment/$siteID/'
    | '/assets/$siteID/'
    | '/parts/$siteID/'
    | '/point-cloud/$siteID/'
    | '/process-flows/$siteID/'
    | '/walkdowns/$siteID/'
    | '/organization_/$orgID/site/$siteID'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AssetsRouteRoute: typeof AssetsRouteRouteWithChildren
  ExplorerRouteRoute: typeof ExplorerRouteRouteWithChildren
  PartsRouteRoute: typeof PartsRouteRouteWithChildren
  ViewerRouteRoute: typeof ViewerRouteRouteWithChildren
  WalkdownsRouteRoute: typeof WalkdownsRouteRouteWithChildren
  FallbackRoute: typeof FallbackRoute
  HealthCheckRoute: typeof HealthCheckRoute
  InventoryRoute: typeof InventoryRoute
  JobsRoute: typeof JobsRoute
  OrganizationRoute: typeof OrganizationRouteWithChildren
  AboutLazyRoute: typeof AboutLazyRoute
  RedirectsLandingRoute: typeof RedirectsLandingRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AssemblyAssemblyIDRoute: typeof AssemblyAssemblyIDRoute
  DetailsEntryIDRoute: typeof DetailsEntryIDRoute
  DrilldownExplorationSiteIDRoute: typeof DrilldownExplorationSiteIDRoute
  EquipmentEquipmentIDRoute: typeof EquipmentEquipmentIDRoute
  ExtensionsOrgIDRoute: typeof ExtensionsOrgIDRoute
  ForgingEntryIDRoute: typeof ForgingEntryIDRoute
  HealthPlansSiteIDRoute: typeof HealthPlansSiteIDRoute
  InspectionsSiteIDRoute: typeof InspectionsSiteIDRoute
  JobSiteIDRoute: typeof JobSiteIDRoute
  MaximoSiteIDRoute: typeof MaximoSiteIDRoute
  NoSitesOrgIDRoute: typeof NoSitesOrgIDRoute
  OverviewSiteIDRoute: typeof OverviewSiteIDRoute
  PointCloudSiteIDRoute: typeof PointCloudSiteIDRouteWithChildren
  SchedulingSiteIDRoute: typeof SchedulingSiteIDRoute
  SubAssemblySubAssemblyIDRoute: typeof SubAssemblySubAssemblyIDRoute
  UsersOrgIDRoute: typeof UsersOrgIDRoute
  WorkOrderWorkOrderIDRoute: typeof WorkOrderWorkOrderIDRoute
  RedirectsIndexRoute: typeof RedirectsIndexRoute
  RedirectsSiteViewSiteIDRoute: typeof RedirectsSiteViewSiteIDRoute
  AssetAssessmentSiteIDUnitIDRoute: typeof AssetAssessmentSiteIDUnitIDRoute
  AssetLensSiteIDUnitIDRoute: typeof AssetLensSiteIDUnitIDRoute
  OrganizationOrgIDSiteRoute: typeof OrganizationOrgIDSiteRouteWithChildren
  ProcessFlowsSiteIDDiagramIDRoute: typeof ProcessFlowsSiteIDDiagramIDRoute
  AssetAssessmentSiteIDIndexRoute: typeof AssetAssessmentSiteIDIndexRoute
  ProcessFlowsSiteIDIndexRoute: typeof ProcessFlowsSiteIDIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  AssetsRouteRoute: AssetsRouteRouteWithChildren,
  ExplorerRouteRoute: ExplorerRouteRouteWithChildren,
  PartsRouteRoute: PartsRouteRouteWithChildren,
  ViewerRouteRoute: ViewerRouteRouteWithChildren,
  WalkdownsRouteRoute: WalkdownsRouteRouteWithChildren,
  FallbackRoute: FallbackRoute,
  HealthCheckRoute: HealthCheckRoute,
  InventoryRoute: InventoryRoute,
  JobsRoute: JobsRoute,
  OrganizationRoute: OrganizationRouteWithChildren,
  AboutLazyRoute: AboutLazyRoute,
  RedirectsLandingRoute: RedirectsLandingRoute,
  AdminUsersRoute: AdminUsersRoute,
  AssemblyAssemblyIDRoute: AssemblyAssemblyIDRoute,
  DetailsEntryIDRoute: DetailsEntryIDRoute,
  DrilldownExplorationSiteIDRoute: DrilldownExplorationSiteIDRoute,
  EquipmentEquipmentIDRoute: EquipmentEquipmentIDRoute,
  ExtensionsOrgIDRoute: ExtensionsOrgIDRoute,
  ForgingEntryIDRoute: ForgingEntryIDRoute,
  HealthPlansSiteIDRoute: HealthPlansSiteIDRoute,
  InspectionsSiteIDRoute: InspectionsSiteIDRoute,
  JobSiteIDRoute: JobSiteIDRoute,
  MaximoSiteIDRoute: MaximoSiteIDRoute,
  NoSitesOrgIDRoute: NoSitesOrgIDRoute,
  OverviewSiteIDRoute: OverviewSiteIDRoute,
  PointCloudSiteIDRoute: PointCloudSiteIDRouteWithChildren,
  SchedulingSiteIDRoute: SchedulingSiteIDRoute,
  SubAssemblySubAssemblyIDRoute: SubAssemblySubAssemblyIDRoute,
  UsersOrgIDRoute: UsersOrgIDRoute,
  WorkOrderWorkOrderIDRoute: WorkOrderWorkOrderIDRoute,
  RedirectsIndexRoute: RedirectsIndexRoute,
  RedirectsSiteViewSiteIDRoute: RedirectsSiteViewSiteIDRoute,
  AssetAssessmentSiteIDUnitIDRoute: AssetAssessmentSiteIDUnitIDRoute,
  AssetLensSiteIDUnitIDRoute: AssetLensSiteIDUnitIDRoute,
  OrganizationOrgIDSiteRoute: OrganizationOrgIDSiteRouteWithChildren,
  ProcessFlowsSiteIDDiagramIDRoute: ProcessFlowsSiteIDDiagramIDRoute,
  AssetAssessmentSiteIDIndexRoute: AssetAssessmentSiteIDIndexRoute,
  ProcessFlowsSiteIDIndexRoute: ProcessFlowsSiteIDIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/assets",
        "/explorer",
        "/parts",
        "/viewer",
        "/walkdowns",
        "/_fallback",
        "/health-check",
        "/inventory",
        "/jobs",
        "/organization",
        "/about",
        "/_redirects/landing",
        "/admin/users",
        "/assembly/$assemblyID",
        "/details/$entryID",
        "/drilldown-exploration/$siteID",
        "/equipment/$equipmentID",
        "/extensions/$orgID",
        "/forging/$entryID",
        "/health-plans/$siteID",
        "/inspections/$siteID",
        "/job/$siteID",
        "/maximo/$siteID",
        "/no-sites/$orgID",
        "/overview/$siteID",
        "/point-cloud/$siteID",
        "/scheduling/$siteID",
        "/sub-assembly/$subAssemblyID",
        "/users/$orgID",
        "/work-order/$workOrderID",
        "/_redirects/",
        "/_redirects/site-view/$siteID",
        "/asset-assessment/$siteID/$unitID",
        "/asset-lens/$siteID/$unitID",
        "/organization_/$orgID/site",
        "/process-flows/$siteID/$diagramID",
        "/asset-assessment/$siteID/",
        "/process-flows/$siteID/"
      ]
    },
    "/assets": {
      "filePath": "assets.route.tsx",
      "children": [
        "/assets/$siteID/$unitID",
        "/assets/$siteID/"
      ]
    },
    "/explorer": {
      "filePath": "explorer.route.tsx",
      "children": [
        "/explorer/$siteID",
        "/explorer/"
      ]
    },
    "/parts": {
      "filePath": "parts.route.tsx",
      "children": [
        "/parts/$siteID/"
      ]
    },
    "/viewer": {
      "filePath": "viewer.route.tsx",
      "children": [
        "/viewer/$unitID/configuration",
        "/viewer/$unitID/inspection"
      ]
    },
    "/walkdowns": {
      "filePath": "walkdowns.route.tsx",
      "children": [
        "/walkdowns/$siteID/$walkdownId",
        "/walkdowns/$siteID/"
      ]
    },
    "/_fallback": {
      "filePath": "_fallback.tsx"
    },
    "/health-check": {
      "filePath": "health-check.tsx"
    },
    "/inventory": {
      "filePath": "inventory.tsx"
    },
    "/jobs": {
      "filePath": "jobs.tsx"
    },
    "/organization": {
      "filePath": "organization.tsx",
      "children": [
        "/organization/$orgID"
      ]
    },
    "/about": {
      "filePath": "about.lazy.tsx"
    },
    "/_redirects/landing": {
      "filePath": "_redirects/landing.tsx"
    },
    "/admin/users": {
      "filePath": "admin.users.tsx"
    },
    "/assembly/$assemblyID": {
      "filePath": "assembly.$assemblyID.tsx"
    },
    "/details/$entryID": {
      "filePath": "details.$entryID.tsx"
    },
    "/drilldown-exploration/$siteID": {
      "filePath": "drilldown-exploration.$siteID.tsx"
    },
    "/equipment/$equipmentID": {
      "filePath": "equipment.$equipmentID.tsx"
    },
    "/explorer/$siteID": {
      "filePath": "explorer.$siteID.tsx",
      "parent": "/explorer"
    },
    "/extensions/$orgID": {
      "filePath": "extensions.$orgID.tsx"
    },
    "/forging/$entryID": {
      "filePath": "forging.$entryID.tsx"
    },
    "/health-plans/$siteID": {
      "filePath": "health-plans.$siteID.tsx"
    },
    "/inspections/$siteID": {
      "filePath": "inspections.$siteID.tsx"
    },
    "/job/$siteID": {
      "filePath": "job.$siteID.tsx"
    },
    "/maximo/$siteID": {
      "filePath": "maximo.$siteID.tsx"
    },
    "/no-sites/$orgID": {
      "filePath": "no-sites.$orgID.tsx"
    },
    "/organization/$orgID": {
      "filePath": "organization.$orgID.tsx",
      "parent": "/organization"
    },
    "/overview/$siteID": {
      "filePath": "overview.$siteID.tsx"
    },
    "/point-cloud/$siteID": {
      "filePath": "point-cloud.$siteID.tsx",
      "children": [
        "/point-cloud/$siteID/$pointCloudOrSceneID",
        "/point-cloud/$siteID/"
      ]
    },
    "/scheduling/$siteID": {
      "filePath": "scheduling.$siteID.tsx"
    },
    "/sub-assembly/$subAssemblyID": {
      "filePath": "sub-assembly.$subAssemblyID.tsx"
    },
    "/users/$orgID": {
      "filePath": "users.$orgID.tsx"
    },
    "/work-order/$workOrderID": {
      "filePath": "work-order.$workOrderID.tsx"
    },
    "/_redirects/": {
      "filePath": "_redirects/index.tsx"
    },
    "/explorer/": {
      "filePath": "explorer.index.tsx",
      "parent": "/explorer"
    },
    "/_redirects/site-view/$siteID": {
      "filePath": "_redirects/site-view.$siteID.tsx"
    },
    "/asset-assessment/$siteID/$unitID": {
      "filePath": "asset-assessment.$siteID.$unitID.tsx"
    },
    "/asset-lens/$siteID/$unitID": {
      "filePath": "asset-lens.$siteID.$unitID.tsx"
    },
    "/assets/$siteID/$unitID": {
      "filePath": "assets.$siteID.$unitID.tsx",
      "parent": "/assets"
    },
    "/organization_/$orgID/site": {
      "filePath": "organization_.$orgID.site.tsx",
      "children": [
        "/organization_/$orgID/site/$siteID"
      ]
    },
    "/point-cloud/$siteID/$pointCloudOrSceneID": {
      "filePath": "point-cloud.$siteID.$pointCloudOrSceneID.tsx",
      "parent": "/point-cloud/$siteID"
    },
    "/process-flows/$siteID/$diagramID": {
      "filePath": "process-flows.$siteID.$diagramID.tsx"
    },
    "/viewer/$unitID/configuration": {
      "filePath": "viewer.$unitID.configuration.tsx",
      "parent": "/viewer"
    },
    "/viewer/$unitID/inspection": {
      "filePath": "viewer.$unitID.inspection.tsx",
      "parent": "/viewer"
    },
    "/walkdowns/$siteID/$walkdownId": {
      "filePath": "walkdowns.$siteID.$walkdownId.tsx",
      "parent": "/walkdowns"
    },
    "/asset-assessment/$siteID/": {
      "filePath": "asset-assessment.$siteID.index.tsx"
    },
    "/assets/$siteID/": {
      "filePath": "assets.$siteID.index.tsx",
      "parent": "/assets"
    },
    "/parts/$siteID/": {
      "filePath": "parts.$siteID.index.tsx",
      "parent": "/parts"
    },
    "/point-cloud/$siteID/": {
      "filePath": "point-cloud.$siteID.index.tsx",
      "parent": "/point-cloud/$siteID"
    },
    "/process-flows/$siteID/": {
      "filePath": "process-flows.$siteID.index.tsx"
    },
    "/walkdowns/$siteID/": {
      "filePath": "walkdowns.$siteID.index.tsx",
      "parent": "/walkdowns"
    },
    "/organization_/$orgID/site/$siteID": {
      "filePath": "organization_.$orgID.site.$siteID.tsx",
      "parent": "/organization_/$orgID/site"
    }
  }
}
ROUTE_MANIFEST_END */
